"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCUpIcon16Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCUpIcon16Regular = forwardRef_1.forwardRef('ArrowCUpIcon16Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M2.973 10.534a.75.75 0 0 1-.007-1.06L6.76 5.63a1.75 1.75 0 0 1 2.483-.008L13.03 9.41a.75.75 0 0 1-1.06 1.06L8.18 6.684a.25.25 0 0 0-.354.002l-3.793 3.842a.75.75 0 0 1-1.06.007Z" })));
});
